import { MemberInformation } from '@streem/sdk-react';
import { Row, styled, Theme } from '@streem/ui-react';
import { useCallDetailHeaderInfo } from '../../../../hooks/use_call_detail_header_info';
import { useCallRequeue } from '../../../../hooks/use_call_requeue';
import { CallDetailDiagnosis } from '../../reservation/call_detail_diagnosis';
import { CallDetailTransferred } from '../../reservation/call_detail_transferred';

export const MemberInformationAndDiagnosis = (): JSX.Element => {
    const { callDetail } = useCallDetailHeaderInfo();
    const { callRequeueEnabled } = useCallRequeue();

    if (!callDetail) {
        return null;
    }

    const { customer } = callDetail;

    return (
        <Wrapper>
            <MemberInfoWrapper paddingTop="1rem">
                <MemberInformation
                    customer={customer}
                    widthPercentage={100}
                    columnsPerRow={1}
                    dataIdPrefix="post-call-details"
                    memberInformationStyles={{ titleFontSize: '1.125rem' }}
                />
            </MemberInfoWrapper>
            {/* The diagnosis component already has a .75rem top margin */}
            <CallDetailsWrapper paddingTop=".25rem">
                <CallDetailDiagnosis />
                {callRequeueEnabled && <CallDetailTransferred />}
            </CallDetailsWrapper>
        </Wrapper>
    );
};

const Wrapper = styled(Row)({
    columnGap: '2rem',
    width: '100%',
});

const MemberInfoWrapper = styled.div<{ paddingTop: string }>(({ paddingTop }) => ({
    border: `1px solid ${Theme.colors.grey10}`,
    borderRadius: '4px',
    padding: `${paddingTop} 1.5rem 1.1rem 1.5rem`,
    width: '50%',
}));

const CallDetailsWrapper = styled(Row)<{ paddingTop: string }>(({ paddingTop }) => ({
    border: `1px solid ${Theme.colors.grey10}`,
    borderRadius: '4px',
    padding: `${paddingTop} 1.5rem 1.1rem 1.5rem`, // the diagnosis component has bottom padding of .4rem
}));
